import React, { useState } from 'react';
import { CustomModal } from 'seagull';
import { ClientOnboarding } from "../../client-flow/clientOb/ClientOnboarding";
import { useStoreActions, useStoreApi } from "../../contexts";
import { CobStorageProvider, mockStorageImpl } from "../../client-flow/clientOb/CobStorageContext";
import { selectors } from "../../store/state-selectors";
import RestfulWrapper from "../RestfulWrapper/RestfulWrapper";
import { COBStep } from "../../client-flow/clientOb/ClientOnboarding.utils";
import { draftToRelationship } from "./AgreementStudio.utils";

function getVendor(worksAt) {
  const {
    branding,
    id,
    logoUrl,
    name,
    postalAddress
  } = worksAt !== null && worksAt !== void 0 ? worksAt : {};
  const {
    addressOne,
    addressTwo,
    city,
    country,
    postalCode,
    state
  } = postalAddress !== null && postalAddress !== void 0 ? postalAddress : {};
  return {
    branding: branding || {
      color: ''
    },
    id: id || '',
    logoUrl: logoUrl || null,
    name: name || '',
    stripeAccountId: '',
    postalAddress: {
      addressOne: addressOne || null,
      addressTwo: addressTwo || null,
      city: city || null,
      country: country || null,
      postalCode: postalCode || null,
      state: state || null
    }
  };
}

function getSeller(userInfo) {
  const user = userInfo !== null && userInfo !== void 0 ? userInfo : {};
  return {
    id: user.id || '',
    firstName: user.firstName || null,
    lastName: user.lastName || null,
    email: user.email || '',
    phone: user.phone || null
  };
}

export function ClientPreview(props) {
  const {
    draft,
    relationshipId,
    contactsMap,
    sampleContact,
    legalTerms,
    dismissModal
  } = props;
  const {
    api
  } = useStoreActions();
  const [currentStep, setCurrentStep] = useState(COBStep.welcome);
  const {
    getState
  } = useStoreApi();
  return /*#__PURE__*/React.createElement(CustomModal, {
    onClose: dismissModal,
    height: "90vh",
    width: "90vw",
    minWidth: "1200px",
    maxHeight: "auto",
    maxWidth: "auto",
    fullSizeHeader: true,
    "data-testid": "client-preview-modal"
  }, /*#__PURE__*/React.createElement(RestfulWrapper, {
    fetch: async () => {
      if (draft) {
        var _getState$userInfo, _sampleContact$custom, _contactsMap$draft$cl;

        const userInfo = (_getState$userInfo = getState().userInfo) !== null && _getState$userInfo !== void 0 ? _getState$userInfo : {};
        const worksAt = selectors.user.business(getState());
        return draftToRelationship(draft, {
          buyer: draft.isSample ? sampleContact : draft.clientContactId ? contactsMap[draft.clientContactId] : undefined,
          vendor: getVendor(worksAt),
          seller: getSeller(userInfo),
          customer: draft.isSample ? {
            id: (_sampleContact$custom = sampleContact.customerId) !== null && _sampleContact$custom !== void 0 ? _sampleContact$custom : '',
            name: sampleContact.companyName
          } : draft.clientContactId && contactsMap[draft.clientContactId] != null ? {
            id: (_contactsMap$draft$cl = contactsMap[draft.clientContactId].customerId) !== null && _contactsMap$draft$cl !== void 0 ? _contactsMap$draft$cl : '',
            name: contactsMap[draft.clientContactId].companyName
          } : draft.customerName ? {
            id: '',
            name: draft.customerName
          } : undefined,
          legalTerms: legalTerms.find(terms => {
            var _draft$legalTerms, _draft$legalTerms2;

            return ((_draft$legalTerms = draft.legalTerms) === null || _draft$legalTerms === void 0 ? void 0 : _draft$legalTerms.type) === 'libraryLegalTermsId' && terms.id === ((_draft$legalTerms2 = draft.legalTerms) === null || _draft$legalTerms2 === void 0 ? void 0 : _draft$legalTerms2.libraryLegalTermsId);
          })
        });
      } else {
        return await api.relationship.get(relationshipId);
      }
    },
    renderChild: _ref => {
      let {
        data
      } = _ref;
      return /*#__PURE__*/React.createElement(CobStorageProvider, {
        impl: mockStorageImpl
      }, /*#__PURE__*/React.createElement(ClientOnboarding, {
        isPreview: true,
        disableMobile: true,
        dismissPreviewModal: dismissModal,
        relationship: data,
        accountants: [],
        currentStep: currentStep,
        setCurrentStep: setCurrentStep
      }));
    }
  }));
}